import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { AppointmentStatusCell, CircleIcon, DATE_FORMATS_FNS } from "components";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";
import { useCarLocation } from "modules/CarDetails/hooks";
import { formatDate } from "utils/dateHelperFunctions";

import type { Appointment } from "models";

type AppointmentHistoryHeaderProps = {
  propertyName: keyof Appointment;
  appointment: Appointment;
  holdingHistory?: boolean;
};

export const AppointmentHistoryHeader = ({ propertyName, appointment, holdingHistory = false }: AppointmentHistoryHeaderProps) => {
  const { t } = useTranslation();

  const carLocation = useCarLocation();
  const appointmentLocation = useAppointmentLocation(appointment);

  switch (propertyName) {
    case "time_car_app":
      return (
        <div>
          <p className="date-wo">
            <span>
              <span className="weak">{t("v8_date", "Date")}:</span> {formatDate(appointment.time_car_app, DATE_FORMATS_FNS.dateMonthYear)}
            </span>
            <span>
              <span className="weak">{t("v8_wo", "WO")}#:</span> {appointment.wo_nr}
            </span>
          </p>
          <p>{t("v8_name", "Name")}</p>
        </div>
      );
    case "dealer_name":
      return (
        <div>
          <p>
            {" "}
            <span className="weak">{t("v8_dealer", "Dealer")}:</span> {appointment.dealer_name || ""}
          </p>
          <p>&nbsp;</p>
        </div>
      );
    case "location_name":
      return (
        <div>
          <p>
            {" "}
            <span className="weak">{t("v8_location", "Location")}:</span> {appointmentLocation?.name || ""}
          </p>
          <p>{t("v8_photo", "Photo")}</p>
        </div>
      );
    case "next_date":
      return (
        <div>
          <p>
            {" "}
            <span className="weak">{t("v8_next_date", "Next date")}:</span> {formatDate(appointment.next_date, DATE_FORMATS_FNS.dateMonthYear)}
          </p>
          <p>{t("v8_critical", "Critical")}</p>
        </div>
      );
    case "current_km":
      return (
        <div>
          <p>
            {" "}
            <span className="weak">{t("v8_current_km", "Current km")}:</span> {appointment.current_km}
          </p>
          <p>{t("v8_critical_approved", "Critical Approved")}</p>
        </div>
      );
    case "next_km":
      return (
        <div>
          <p>
            {" "}
            <span className="weak">{t("v8_next_km", "Next km")}:</span> {appointment.next_km}
          </p>
          <p>{t("v8_advisable", "Advisable")}</p>
        </div>
      );
    case "reg_number":
      return (
        <div>
          <p>
            {" "}
            <span className="weak">{t("v8_registration", "Registration")}:</span> {appointment.reg_number}
          </p>
          <p>{t("v8_advisable_approved", "Advisable Approved")}</p>
        </div>
      );
    case "id":
      return (
        <>
          <div className="item-buttons">
            {appointment.is_money && (
              <div className="button-icon">
                <CircleIcon icon="is_money" />
              </div>
            )}
            <div className="small-status">
              <AppointmentStatusCell value={{ id: appointment.appointment_status_identifier }} statuses={carLocation?.statuses} />
            </div>
            <div className="button-icon">
              <Link to={holdingHistory ? `/holding/appointments/${appointment.id}` : `/appointments/${appointment.id}`} target="_blank" className="workorder">
                <Button className="-appointment-status" size="small">
                  <Icon className="arrow up right from square" color="green" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="empty" />
        </>
      );
    default:
      return null;
  }
};
